/**
 * Navigation utility for performing hard navigation.
 * This abstraction allows for easy mocking in tests where jsdom's
 * window.location is difficult to mock.
 */
export const navigateTo = (url: string): void => {
  window.location.href = url;
};

export const reload = (): void => {
  window.location.reload();
};
